module.exports = __webpack_public_path__ + "img/Flag_of_Saint-Pierre_and_Miquelon.d0985ab6.svg";